<app-create-account *transloco="let t">
  <app-main-header header>{{ t('create-account') }}</app-main-header>
  <app-header form-header>{{ t('create-business-representative-account') }}</app-header>
  <app-business-representative-form
    [formGroup]="businessRepresentative.formGroup"
    businessRepresentativeForm
    [businessRepresentative]="businessRepresentative"
    [animateImage]="loading">
  </app-business-representative-form>
  <app-checkbox [formGroup]="termsFormGroup"
                abstractFormControlName="agree"
                id="create-account-agree-checkbox"
                [label]="businessRepresentative.labels.agree"
                [anchorTermsText]="businessRepresentative.labels.termsAndConditions"
                [anchorTermsLink]="businessRepresentative.termsAndConditionsLink || ''"
                [anchorPrivacyText]="businessRepresentative.labels.privacy"
                [anchorPrivacyLink]="businessRepresentative.privacyPolicyLink || ''"
                [isInvited]="true"
                businessRepresentativeForm>
  </app-checkbox>
  <app-recaptcha  *ngIf="recaptchaEnabled"
                  businessRepresentativeForm
                  id="recaptcha-register-invited"
                  [formGroup]="recaptchaFormGroup"
                  abstractFormControlName="recaptcha"
                  #captchaRef>
  </app-recaptcha>
  <app-label *ngIf="errorMsg" isError>
    {{ errorMsg }}
  </app-label>
  <div buttonSection>
    <app-primary-button
      id="lnr-invite-create-account"
      (click)="onCreateAccount()"
      [abstractControl]="businessRepresentative.formGroup"
      type="submit"
      [disabled]="checkDisabled()">
      {{ t('create-account') }}
    </app-primary-button>
  </div>
</app-create-account>
